var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3869 10.3535L17.7404 9.99998L17.3869 9.64642L12.7702 5.02976C12.7487 5.00823 12.7354 4.97749 12.7354 4.94164C12.7354 4.90579 12.7487 4.87506 12.7702 4.85353C12.7917 4.832 12.8225 4.81873 12.8583 4.81873C12.8942 4.81873 12.9249 4.832 12.9464 4.85353L18.0048 9.91186C18.0263 9.93339 18.0396 9.96413 18.0396 9.99998C18.0396 10.0358 18.0263 10.0666 18.0048 10.0881L12.9464 15.1464C12.9318 15.1611 12.9177 15.1695 12.9049 15.1747C12.8915 15.1801 12.876 15.1833 12.8583 15.1833C12.8406 15.1833 12.8251 15.1801 12.8118 15.1747C12.7989 15.1695 12.7849 15.1611 12.7702 15.1464C12.7487 15.1249 12.7354 15.0942 12.7354 15.0583C12.7354 15.0225 12.7487 14.9917 12.7702 14.9702L17.3869 10.3535Z",
    fill: "#313131",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.775 10.125H3.75C3.71985 10.125 3.68857 10.1127 3.66293 10.0871C3.63728 10.0614 3.625 10.0301 3.625 10C3.625 9.96985 3.63728 9.93857 3.66293 9.91293C3.68857 9.88728 3.71985 9.875 3.75 9.875H17.775C17.8051 9.875 17.8364 9.88728 17.8621 9.91293C17.8877 9.93857 17.9 9.96985 17.9 10C17.9 10.0301 17.8877 10.0614 17.8621 10.0871C17.8364 10.1127 17.8051 10.125 17.775 10.125Z",
    fill: "#313131",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.b8691b289f1c99b47cc51633a8c38867.svg";
export { ForwardRef as ReactComponent };